<template>
  <div id="app">
    <template v-if="initialized">
      <!-- RouterView handles all routing including AppLayout -->
      <RouterView />
    </template>

    <div v-else class="flex flex-col items-center justify-center min-h-screen gap-md">
      <div class="spinner"></div>
      <p class="text-text-muted text-base">Loading...</p>
    </div>

    <NotificationToast />
    <ConfirmDialog />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { RouterView, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import NotificationToast from '@/components/NotificationToast.vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'

const router = useRouter()
const authStore = useAuthStore()
const initialized = ref(false)

onMounted(async () => {
  const currentPath = router.currentRoute.value.path
  if (currentPath !== '/login' && currentPath !== '/') {
    try {
      await authStore.checkSession()
    } catch (error) {
      console.error('Initial session check failed:', error)
    }
  }
  initialized.value = true
})
</script>

<!-- No styles needed - all in Tailwind -->
